module.exports = __webpack_public_path__ + "static/logo-150-ans-2x-39f03a28319403f065849a953baaf69a.png";